const initializeClickTracking = () => {
  $('a[data-trackable-id]').on('click', function() {
    const athlete_id = $("#page-athlete").data('trackable-id')
    $.post('/analytics/clicks', { click: { athlete: athlete_id, id: $(this).data('trackable-id'), type: $(this).data('trackable-type') } })
  });
}

module.exports = initializeClickTracking